import { render, staticRenderFns } from "./Tacho.vue?vue&type=template&id=2f914fc1&scoped=true&"
import script from "./Tacho.vue?vue&type=script&lang=js&"
export * from "./Tacho.vue?vue&type=script&lang=js&"
import style0 from "./Tacho.vue?vue&type=style&index=0&id=2f914fc1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f914fc1",
  null
  
)

export default component.exports